import "@/App.css";

function App() {
  return null;
}

export default App;
